import { useEffect, useState } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import Home from "./components/Home";
import Contact from "./components/Contact";
import WebsiteLoader from "./components/WebsiteLoader";
import ParticlesBackground from "./components/Home/components/ParticlesBackground";

import "./App.css";

var loaderTimer = null;

const loadScript = (src) => {
  return new Promise((resolve, reject) => {
    let script = document.createElement("script");
    script.src = src;

    script.onload = () => {
      resolve(true);
    };

    script.onerror = () => {
      resolve(false);
    };

    document.body.appendChild(script);
  });
};

function App() {
  const [showInitialLoader, setshowInitialLoader] = useState(true);

  useEffect(() => {
    if (loaderTimer) clearTimeout(loaderTimer);
    loaderTimer = setTimeout(() => {
      setshowInitialLoader(false);
    }, 3600);

    return () => {
      if (loaderTimer) clearTimeout(loaderTimer);
    };
  }, []);

  useEffect(() => {
    loadSetmore();
  }, []);

  const loadSetmore = async () => {
    let res = await loadScript(
      // "https://assets.calendly.com/assets/external/widget.js"
      "https://my.setmore.com/webapp/js/src/others/setmore_iframe.js"
    );

    if (!res) {
      alert("not loaded");
      return;
    }
  };

  return (
    <>
      {showInitialLoader ? (
        <WebsiteLoader />
      ) : (
        <>
          <ParticlesBackground amount={10} />

          <Router>
            <Switch>
              <Route path="/" component={Home} exact />
              <Route path="/contact" component={Contact} exact />
            </Switch>
          </Router>
        </>
      )}
    </>
  );
}

export default App;
